import React from 'react';
import IssueDetail from 'components/IssueDetail';

const Detail: React.FC = () => {
  return <IssueDetail />;
};

export default Detail;
